import axios from "axios"
import Loader from "components/Loader/loader"
import React, { createContext, useContext, useEffect, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import { fetchData } from "utils/Common_api_functions"

const RolesContext = createContext()

export const usePermissionData = () => {
  return useContext(RolesContext)
}

export const AppContext = ({ children }) => {
  const [permissions, setPermissions] = useState([])
  const [loginStatus, setLoginStatus] = useState(false)

  const [loading, setloading] = useState(false)

  useEffect(() => {
    if (permissions.length === 0) {
      getStaffInfo()
    }
  }, [])

  async function getStaffInfo() {
    const APIdata = await fetchData(
      setloading,
      "roles-and-permissions/get-permissions"
    )
    if (APIdata?.success) {
      const parsed = JSON.parse(APIdata?.permissions)

      setPermissions(parsed)
      secureLocalStorage.setItem("permissions", parsed)
    }
  }

  // Check Access Function
  const checkAccess = (mod_id, type) => {
    return permissions?.some(temp => {
      const permissionArray = temp.split(",")
      return permissionArray[0] == mod_id && permissionArray[type] == "1"
    })
  }

  return (
    <RolesContext.Provider
      value={{ permissions, checkAccess, loginStatus, setLoginStatus }}
    >
      {loading && <Loader />}
      {children}
    </RolesContext.Provider>
  )
}
